import React from "react";

// Components
import SectionWrapper from "../../components/SectionWrapper";
import CaseMediaPanel from "../../components/CaseMediaPanel";
import CaseMediaRoutes from "./CaseMediaRoutes";
import CaseMediaPanelLayout from "./CaseMediaPanelLayout";

const CaseMediaPage = () => (
  <SectionWrapper>
    <CaseMediaPanelLayout>
      <CaseMediaPanel />
    </CaseMediaPanelLayout>
    <CaseMediaRoutes />
  </SectionWrapper>
);

export default CaseMediaPage;
